/* ==========================================================================
   TestHelden v2 · assets/th-v2-header.js
   Portiert aus dem Designsystem (testhelden-designsystem/system/js/navigation.js, core.js), Stand 15.10.2026.
   Vanilla JS, kein Build, progressive Verbesserung (ohne JS: Links, Suchformular, /cart), idempotent (WeakSet),
   bindet neu bei shopify:section:load.

   Bindet:
     [data-th-v2-hdr]               Header: verkleinert sich ab 80 px Scrollweg (is-compact), nur wenn er wirklich klebt
     [data-th-mega-trigger="n"]     Mega-Menü: Hover 120 ms, Klick toggelt, Enter/Leertaste, Pfeil ↓ ins Panel,
                                    ←/→ zwischen Hauptpunkten bzw. Spalten, Tab vom offenen Auslöser ins Panel,
                                    Shift+Tab zurück, Esc schließt und fokussiert den Auslöser, Klick außerhalb/Tab raus schließt
     [data-th-nav-drawer]           mobile Navigation mit Ebenen (data-th-nav-goto, data-th-nav-back), Fokusfalle,
                                    Hintergrund inert, Scroll-Sperre, Esc, Scrim; Ebenentitel wird beim Wechsel fokussiert
     [data-th-search]               Suche: Header-Feld (Desktop-Dropdown) und Vollbild (mobil, modaler Dialog),
                                    Treffer aus der Predictive Search API über die Section th-v2-predictive-search,
                                    Zustände leer/laden/treffer/null, Combobox mit aria-activedescendant (↑/↓/Enter/Esc)
     [data-th-v2-cart-open]         Warenkorb-Knopf: öffnet Philipps cart-drawer-component wie Horizon/th-v2.js
                                    (drawer.returnFocusTo + drawer.open()); Zähler folgt dem Ereignis cart:update
     [data-th-v2-announcement]      Ankündigung schließen; gemerkt (sessionStorage) nur mit Einwilligung in Präferenzen
     Steuerhinweis (Abschnitt 7)    Absicherung für Kaufwege ohne properties[Hinweis] (Philipps Quick-Add, Bought-together,
                                    Drawer-Upgrade …): nach cart:update bzw. beim Laden (data-th-v2-steuer-offen) bekommen
                                    nicht steuerpflichtige Positionen (taxable false = § 4 Nr. 21 UStG) per /cart/change.js die
                                    Property „Hinweis“; steuerpflichtige verlieren einen falschen Befreiungshinweis.
   ========================================================================== */
(function () {
  'use strict';

  if (window.thV2Header) { window.thV2Header.init(document); return; }

  /* ---------- Helfer ---------- */
  var gebunden = typeof WeakSet === 'function' ? new WeakSet() : null;
  function einmal(el, schluessel) {
    var k = '__thV2Hdr' + (schluessel || '');
    if (!gebunden || schluessel) { if (el[k]) { return false; } el[k] = true; return true; }
    if (gebunden.has(el)) { return false; }
    gebunden.add(el);
    return true;
  }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var mm = window.matchMedia ? function (q) { return window.matchMedia(q); } : function () { return { matches: false }; };
  var reduziert = mm('(prefers-reduced-motion: reduce)').matches;
  var desktop = mm('(min-width: 1024px)');
  function beiWechsel(mq, fn) {
    if (mq.addEventListener) { mq.addEventListener('change', fn); } else if (mq.addListener) { mq.addListener(fn); }
  }

  /* Esc-Stapel: der zuletzt geöffnete Layer schließt zuerst */
  var escStapel = [];
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape' || !escStapel.length) { return; }
    var oberster = escStapel[escStapel.length - 1];
    if (oberster(ev) !== false) { ev.preventDefault(); }
  });
  function onEsc(fn) {
    escStapel.push(fn);
    return function () { var i = escStapel.lastIndexOf(fn); if (i > -1) { escStapel.splice(i, 1); } };
  }

  /* Fokussierbare Elemente (tabindex −1 nie Teil der Tab-Folge, 3b-3) */
  var NICHT_TAB = ':not([tabindex="-1"])';
  var FOKUSSIERBAR = ['a[href]' + NICHT_TAB, 'button:not([disabled])' + NICHT_TAB,
    'input:not([disabled]):not([type="hidden"])' + NICHT_TAB, 'select:not([disabled])' + NICHT_TAB,
    'textarea:not([disabled])' + NICHT_TAB, 'summary' + NICHT_TAB, '[tabindex]' + NICHT_TAB].join(', ');
  function sichtbar(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && !el.closest('[hidden]') && !el.closest('[inert]');
  }
  function fokussierbare(root) { return qsa(FOKUSSIERBAR, root).filter(sichtbar); }

  function fokusfalle(el, start) {
    var vorher = document.activeElement;
    function tab(ev) {
      if (ev.key !== 'Tab') { return; }
      var liste = fokussierbare(el);
      if (!liste.length) { ev.preventDefault(); el.focus(); return; }
      var erstes = liste[0], letztes = liste[liste.length - 1];
      if (ev.shiftKey && (document.activeElement === erstes || document.activeElement === el)) { ev.preventDefault(); letztes.focus(); }
      else if (!ev.shiftKey && document.activeElement === letztes) { ev.preventDefault(); erstes.focus(); }
    }
    el.addEventListener('keydown', tab);
    var ziel = start || fokussierbare(el)[0] || el;
    if (ziel === el && !el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '-1'); }
    window.requestAnimationFrame(function () { ziel.focus(); });
    return {
      loesen: function (zurueck) {
        el.removeEventListener('keydown', tab);
        var z = zurueck || vorher;
        if (z && typeof z.focus === 'function' && document.contains(z)) { z.focus(); }
      }
    };
  }

  /* Hintergrund inert: alle Geschwister entlang des Pfads vom Dialog bis <body> (WCAG 2.4.3) */
  function hintergrundInert(dialog) {
    var pfad = [];
    var el = dialog;
    while (el && el !== document.body && el !== document.documentElement) { pfad.push(el); el = el.parentElement; }
    var gesetzt = [];
    pfad.forEach(function (p) {
      var eltern = p.parentElement;
      if (!eltern) { return; }
      Array.prototype.slice.call(eltern.children).forEach(function (kind) {
        if (pfad.indexOf(kind) > -1 || kind.tagName === 'SCRIPT' || kind.tagName === 'STYLE' || kind.tagName === 'LINK') { return; }
        if (kind.contains(dialog) || kind.inert) { return; }
        kind.inert = true;
        gesetzt.push(kind);
      });
    });
    return function () { gesetzt.forEach(function (k) { k.inert = false; }); gesetzt = []; };
  }

  var sperrZaehler = 0;
  function sperreScroll(an) {
    sperrZaehler = Math.max(0, sperrZaehler + (an ? 1 : -1));
    document.documentElement.classList.toggle('th-v2-scroll-lock', sperrZaehler > 0);
  }

  /* ======================================================================
     1. Header: Sticky-Verkleinerung
     ====================================================================== */
  function initHeader(hdr) {
    if (!einmal(hdr)) { return; }
    var nav = qs('.th-nav', hdr);
    var huelle = hdr.closest('.shopify-section') || hdr.parentElement;
    if (nav && hdr.getAttribute('data-th-header') === 'sticky') {
      var wartet = false;
      var klebt = function () { return !!huelle && window.getComputedStyle(huelle).position === 'sticky'; };
      /* Liegt der Header im Fluss (Sticky-Kaufleiste), gibt es keine Verkleinerung (Layout-Shift, Korrekturrunde 1) */
      var pruefe = function () { nav.classList.toggle('is-compact', klebt() && window.scrollY > 80); };
      window.addEventListener('scroll', function () {
        if (wartet) { return; }
        wartet = true;
        window.requestAnimationFrame(function () { wartet = false; pruefe(); });
      }, { passive: true });
      pruefe();
    }
    initEng(hdr);
    initMega(hdr);
    initDrawer(hdr);
    initSuche(hdr);
    initWarenkorb(hdr);
  }

  /* Kompakte Kopfzeile (is-eng): Bedarf der Desktop-Leiste = Logo + Hauptpunkte + Suchfeld (mind. 140 px) + „Anmelden“
     + Warenkorb + Abstände. Ist er größer als die Leiste (200 % Text, WCAG 1.4.4), gilt die mobile Bauform. Hauptpunkte
     und „Anmelden“ bleiben dabei unsichtbar im Layout, deshalb misst die Funktion in beiden Zuständen gleich. */
  function initEng(hdr) {
    var bar = qs('.th-nav__bar', hdr), home = qs('.th-nav__home', hdr), liste = qs('.th-nav__list', hdr);
    var login = qs('.th-nav__login', hdr), cart = qs('.th-nav__cart', hdr);
    if (!bar || !home || !liste) { return; }
    var geplant = false;
    function pruefe() {
      geplant = false;
      if (!desktop.matches) { hdr.classList.remove('is-eng'); return; }
      var cs = window.getComputedStyle(bar);
      var gap = parseFloat(cs.columnGap) || 0;
      var innen = bar.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      var bedarf = home.offsetWidth + liste.offsetWidth + 140 + (login ? login.offsetWidth : 0) + (cart ? cart.offsetWidth : 0) + 4 * gap;
      var eng = bedarf > innen;
      if (eng !== hdr.classList.contains('is-eng')) {
        /* Wechsel der Bauform: offene Layer der anderen Bauform schließen (sonst blieben inert/Scroll-Sperre stehen) */
        if (eng && hdr.__thV2MegaZu) { hdr.__thV2MegaZu(false); }
        if (!eng && hdr.__thV2DrawerZu) { hdr.__thV2DrawerZu(); }
        if (hdr.__thV2SucheZu) { hdr.__thV2SucheZu(); }
        hdr.classList.toggle('is-eng', eng);
      }
    }
    function planen() { if (!geplant) { geplant = true; window.requestAnimationFrame(pruefe); } }
    pruefe();
    window.addEventListener('resize', planen);
    if (typeof ResizeObserver === 'function') { new ResizeObserver(planen).observe(liste); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(planen); }
  }

  /* ======================================================================
     2. Mega-Menü (Desktop)
     ====================================================================== */
  function initMega(hdr) {
    var kopf = qs('.th-nav', hdr);
    var mega = qs('[data-th-mega]', hdr);
    var triggers = qsa('[data-th-mega-trigger]', hdr);
    if (!kopf || !mega || !triggers.length || !einmal(mega)) { return; }

    var offen = null, hoverTimer = null, leaveTimer = null, escAb = null, merkTrigger = null;

    function panelFuer(t) { return qs('[data-th-mega-panel="' + t.getAttribute('data-th-mega-trigger') + '"]', mega); }
    function schliesse(fokus) {
      if (!offen) { return; }
      var t = offen, p = panelFuer(t);
      if (p) { p.hidden = true; }
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('is-open');
      offen = null;
      if (escAb) { escAb(); escAb = null; }
      var ziel = merkTrigger || t;
      merkTrigger = null;
      if (fokus) { ziel.focus(); }
    }
    function oeffne(t, perTastatur) {
      if (offen === t) { if (perTastatur) { merkTrigger = t; } return; }
      schliesse(false);
      var p = panelFuer(t);
      if (!p) { return; }
      p.hidden = false;
      t.setAttribute('aria-expanded', 'true');
      t.classList.add('is-open');
      offen = t;
      merkTrigger = perTastatur ? t : null;
      escAb = onEsc(function () { schliesse(true); });
    }
    function spalten(p) { return qsa('[data-th-mega-col]', p); }

    triggers.forEach(function (t, i) {
      var p = panelFuer(t);
      t.addEventListener('click', function () {
        if (offen === t) { schliesse(false); } else { oeffne(t, true); }
      });
      t.addEventListener('mouseenter', function () {
        if (!desktop.matches) { return; }
        window.clearTimeout(leaveTimer);
        window.clearTimeout(hoverTimer);
        hoverTimer = window.setTimeout(function () { oeffne(t); }, 120);
      });
      t.addEventListener('mouseleave', function () {
        window.clearTimeout(hoverTimer);
        leaveTimer = window.setTimeout(function () { if (offen === t && !merkTrigger) { schliesse(false); } }, 200);
      });
      t.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown') {
          ev.preventDefault();
          oeffne(t, true);
          var erstes = p ? fokussierbare(p)[0] : null;
          if (erstes) { erstes.focus(); }
        } else if (ev.key === 'ArrowRight' || ev.key === 'ArrowLeft') {
          ev.preventDefault();
          var n = triggers[(i + (ev.key === 'ArrowRight' ? 1 : triggers.length - 1)) % triggers.length];
          var war = !!offen;
          n.focus();
          if (war) { oeffne(n, true); }
        } else if (ev.key === 'Tab' && !ev.shiftKey && offen === t && p) {
          /* Tab vom offenen Auslöser führt in das Panel (WCAG 2.4.3), nicht zu den Nachbar-Auslösern */
          var erster = fokussierbare(p)[0];
          if (erster) { ev.preventDefault(); erster.focus(); }
        }
      });
      t.addEventListener('focusout', function (ev) {
        var ziel = ev.relatedTarget;
        if (offen === t && ziel && p && !p.contains(ziel) && triggers.indexOf(ziel) === -1) { schliesse(false); }
      });
      if (!p) { return; }
      p.addEventListener('mouseenter', function () { window.clearTimeout(leaveTimer); window.clearTimeout(hoverTimer); });
      p.addEventListener('mouseleave', function () {
        leaveTimer = window.setTimeout(function () { if (offen === t && !merkTrigger) { schliesse(false); } }, 200);
      });
      p.addEventListener('focusout', function (ev) {
        var ziel = ev.relatedTarget;
        if (ziel && !p.contains(ziel) && ziel !== t) { schliesse(false); }
      });
      p.addEventListener('keydown', function (ev) {
        var alle = fokussierbare(p);
        if (ev.key === 'Tab' && ev.shiftKey && document.activeElement === alle[0]) {
          ev.preventDefault();                                   /* Shift+Tab vom ersten Panel-Link zurück zum Auslöser */
          t.focus();
          return;
        }
        /* Tab vom letzten Panel-Link: nächstes Element der Kopfzeile nach dem Auslöser (3b-2) */
        if (ev.key === 'Tab' && !ev.shiftKey && document.activeElement === alle[alle.length - 1]) {
          var leiste = fokussierbare(kopf).filter(function (el) { return !el.closest('[data-th-mega-panel]'); });
          var nach = leiste[leiste.indexOf(t) + 1];
          if (nach) { ev.preventDefault(); schliesse(false); nach.focus(); }
          return;
        }
        var tasten = ['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (tasten.indexOf(ev.key) === -1) { return; }
        var cols = spalten(p);
        if (!cols.length) { return; }
        var aktiv = document.activeElement, ci = -1, li = -1;
        cols.forEach(function (c, ix) { var l = fokussierbare(c).indexOf(aktiv); if (l > -1) { ci = ix; li = l; } });
        if (ci === -1) { ci = 0; li = -1; }
        var liste = fokussierbare(cols[ci]);
        var ziel = null;
        if (ev.key === 'ArrowDown') { ziel = liste[Math.min(li + 1, liste.length - 1)]; }
        else if (ev.key === 'ArrowUp') { ziel = li <= 0 ? t : liste[li - 1]; }
        else if (ev.key === 'Home') { ziel = liste[0]; }
        else if (ev.key === 'End') { ziel = liste[liste.length - 1]; }
        else {
          var nc = ci + (ev.key === 'ArrowRight' ? 1 : -1);
          if (nc < 0 || nc >= cols.length) { return; }
          var nl = fokussierbare(cols[nc]);
          ziel = nl[Math.min(Math.max(li, 0), nl.length - 1)];
        }
        if (ziel) { ev.preventDefault(); ziel.focus(); }
      });
    });

    document.addEventListener('pointerdown', function (ev) {
      if (offen && !kopf.contains(ev.target)) { schliesse(false); }
    });
    beiWechsel(desktop, function () { schliesse(false); });
    hdr.__thV2MegaZu = schliesse;
  }

  /* ======================================================================
     3. Mobile Navigation: Drawer mit Ebenen
     ====================================================================== */
  function initDrawer(hdr) {
    var drawer = qs('[data-th-nav-drawer]', hdr);
    if (!drawer || !einmal(drawer)) { return; }
    var panel = qs('.th-nav-drawer__panel', drawer);
    var levels = qsa('[data-th-nav-level]', drawer);
    var titel = qs('[data-th-nav-title]', drawer);
    var back = qs('[data-th-nav-back]', drawer);
    var backLabel = qs('[data-th-nav-back-label]', drawer);
    var oeffner = qsa('[data-th-nav-open]', hdr);
    var falle = null, escAb = null, inertAb = null, timer = null, rueckweg = {}, ausloeser = null;

    function level(id) { return levels.filter(function (l) { return l.getAttribute('data-th-nav-level') === id; })[0] || null; }
    function zeige(id, richtung) {
      var ziel = level(id);
      if (!ziel) { return null; }
      levels.forEach(function (l) { l.hidden = l !== ziel; l.classList.remove('is-vor', 'is-zurueck'); });
      if (richtung && !reduziert) { ziel.classList.add(richtung === 'vor' ? 'is-vor' : 'is-zurueck'); }
      if (titel) { titel.textContent = ziel.getAttribute('data-th-nav-label') || ''; }
      var parent = ziel.getAttribute('data-th-nav-parent');
      if (back) {
        back.hidden = !parent;
        var eltern = parent ? level(parent) : null;
        if (backLabel && eltern) { backLabel.textContent = eltern.getAttribute('data-th-nav-label') || 'Zurück'; }
      }
      ziel.scrollTop = 0;
      drawer.setAttribute('data-th-nav-aktiv', id);
      return ziel;
    }
    function aktivId() { return drawer.getAttribute('data-th-nav-aktiv') || '0'; }

    drawer.addEventListener('click', function (ev) {
      var go = ev.target.closest('[data-th-nav-goto]');
      if (go) {
        var zielId = go.getAttribute('data-th-nav-goto');
        rueckweg[zielId] = go;
        /* WCAG 4.1.3/2.4.6: Fokus auf den neuen Ebenentitel (h2, tabindex −1) */
        if (zeige(zielId, 'vor') && titel) { titel.focus(); }
        return;
      }
      if (ev.target.closest('[data-th-nav-back]')) {
        var jetzt = aktivId();
        var l = level(jetzt);
        zeige((l && l.getAttribute('data-th-nav-parent')) || '0', 'zurueck');
        var knopf = rueckweg[jetzt];
        if (knopf && document.contains(knopf)) { knopf.focus(); }
        return;
      }
      if (ev.target.closest('[data-th-nav-close]')) { schliesse(); }
    });

    function oeffne(btn) {
      if (!drawer.hidden && drawer.classList.contains('is-open')) { return; }
      window.clearTimeout(timer);
      ausloeser = btn || null;
      drawer.hidden = false;
      zeige('0');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
      sperreScroll(true);
      inertAb = hintergrundInert(drawer);
      falle = fokusfalle(panel, qs('[data-th-nav-close]', panel));
      escAb = onEsc(function () { schliesse(); });
      oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function schliesse() {
      if (drawer.hidden) { return; }
      drawer.classList.remove('is-open');
      oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (escAb) { escAb(); escAb = null; }
      sperreScroll(false);
      if (inertAb) { inertAb(); inertAb = null; }
      if (falle) { falle.loesen(ausloeser); falle = null; }
      timer = window.setTimeout(function () { drawer.hidden = true; zeige('0'); }, reduziert ? 0 : 350);
    }

    zeige('0');
    oeffner.forEach(function (btn) {
      if (!einmal(btn)) { return; }
      btn.addEventListener('click', function () { oeffne(btn); });
    });
    hdr.__thV2DrawerZu = schliesse;
    beiWechsel(desktop, function (e) { if (e.matches) { window.requestAnimationFrame(function () { if (!hdr.classList.contains('is-eng')) { schliesse(); } }); } });
  }

  /* ======================================================================
     4. Suche: Header-Feld + Overlay, Predictive Search über Section Rendering
     ====================================================================== */
  function initSuche(hdr) {
    var wrap = qs('[data-th-search]', hdr);
    var overlay = wrap ? qs('[data-th-search-overlay]', wrap) : null;
    if (!wrap || !overlay || !einmal(overlay)) { return; }

    var inputs = qsa('[data-th-search-input]', wrap);
    var zonen = qsa('[data-th-search-zone]', overlay);
    var fuss = qs('[data-th-search-fuss]', overlay);
    var liste = qs('[data-th-search-liste]', overlay);
    var status = qs('[data-th-search-status]', overlay);
    var alleLink = qs('[data-th-search-alle]', overlay);
    var oeffner = qsa('[data-th-search-open]', hdr);
    var suchUrl = hdr.getAttribute('data-search-url') || '/search';
    var vorschlagUrl = hdr.getAttribute('data-suggest-url') || '/search/suggest';
    var standardControls = (inputs[0] && inputs[0].getAttribute('aria-controls')) || '';
    var aktivInput = null, modus = null, timer = null, falle = null, escAb = null, inertAb = null;
    var aktivIx = -1, letzte = '', fokusRuhe = false, laufend = null, cache = {}, meldeTimer = null;

    function melde(text) {
      if (!status) { return; }
      window.clearTimeout(meldeTimer);
      status.textContent = '';
      if (text) { meldeTimer = window.setTimeout(function () { status.textContent = text; }, 120); }
    }
    /* WAI-ARIA 1.2 Combobox (3b-3): aria-controls nennt die sichtbaren Listboxen, aria-expanded nur mit Optionen */
    function comboAbgleichen() {
      var listen = overlay.hidden ? [] : qsa('[role="listbox"]', overlay).filter(function (l) {
        return l.id && !l.closest('[hidden]') && qs('[role="option"]', l);
      });
      inputs.forEach(function (i) {
        i.setAttribute('aria-expanded', listen.length ? 'true' : 'false');
        i.setAttribute('aria-controls', listen.length ? listen.map(function (l) { return l.id; }).join(' ') : standardControls);
      });
    }
    function optionen() { return qsa('[role="option"]', overlay).filter(function (o) { return !o.closest('[hidden]'); }); }
    function markiere(ix) {
      var opts = optionen();
      opts.forEach(function (o, i) {
        var an = i === ix;
        o.classList.toggle('is-active', an);
        if (o.parentNode && o.parentNode.classList) { o.parentNode.classList.toggle('is-active', an); }
        o.setAttribute('aria-selected', an ? 'true' : 'false');
      });
      aktivIx = ix;
      if (aktivInput) {
        if (ix > -1 && opts[ix]) { aktivInput.setAttribute('aria-activedescendant', opts[ix].id); opts[ix].scrollIntoView({ block: 'nearest' }); }
        else { aktivInput.removeAttribute('aria-activedescendant'); }
      }
    }
    function zustand(name) {
      zonen.forEach(function (z) { z.hidden = z.getAttribute('data-th-search-zone') !== name; });
      markiere(-1);
      if (fuss) { fuss.hidden = name !== 'treffer'; }
      qsa('[data-th-search-query]', overlay).forEach(function (s) { s.textContent = letzte; });
      if (alleLink) { alleLink.setAttribute('href', suchUrl + '?q=' + encodeURIComponent(kuerzel(letzte)) + '&options%5Bprefix%5D=last'); }
      overlay.setAttribute('data-th-search-zustand', name);
      comboAbgleichen();
    }
    /* Gängige Kürzel und Schreibweisen auf den Begriff abbilden, unter dem die Trainer geführt sind (Tom 16.10.2026) */
    var KUERZEL = { 'bw': 'bundeswehr', 'bund': 'bundeswehr', 'bpol': 'bundespolizei', 'bupo': 'bundespolizei', 'lapo': 'polizei',
      'öd': 'öffentlicher dienst', 'oed': 'öffentlicher dienst', 'oeffentlicher dienst': 'öffentlicher dienst', 'feuerwehrmann': 'feuerwehr',
      'ausbilderschein': 'aevo', 'ada': 'aevo', 'ada schein': 'aevo', 'kompass': 'kompass 4', 'oesterreich': 'österreich',
      'einstellungstest polizei': 'polizei', 'einstellungstest bundeswehr': 'bundeswehr', 'einstellungstest zoll': 'zoll',
      /* aus der Shopify-Suchstatistik: Begriffe ohne oder mit falschen Treffern, obwohl es den Trainer gibt (27.10.2026) */
      'medizinischer dienst': 'md', 'medizinische dienst': 'md', 'ac medizinischer dienst': 'md', 'ac mediziischer dienst': 'md',
      'luftwaffe': 'bundeswehr', 'bundeswehr saz': 'bundeswehr', 'saz': 'bundeswehr', 'marine': 'bundeswehr',
      'diplomat': 'auswärtiges amt', 'diplomatin': 'auswärtiges amt', 'auswärtige amt': 'auswärtiges amt', 'auswärtiges': 'auswärtiges amt',
      'auswärtiger dienst': 'auswärtiges amt', 'gehobenen auswärtigen dienst': 'auswärtiges amt', 'gehobener auswärtiger dienst': 'auswärtiges amt',
      'dtz': 'deutsch b1', 'deutsch-test für zuwanderer': 'deutsch b1', 'deutschtest für zuwanderer': 'deutsch b1',
      'hauptzollamt': 'zoll', 'zollbeamter': 'zoll', 'zollbeamtin': 'zoll',
      'mittlerer zolldienst': 'zoll mittlerer dienst', 'zollbeamter mittlerer dienst': 'zoll mittlerer dienst',
      'justizvollzug': 'jva', 'justizvollzugsbeamter': 'jva', 'justizvollzugsbeamtin': 'jva', 'justizvollzugsdienst': 'jva', 'vollzug': 'jva', 'vollzugsdienst': 'jva',
      'niedersächsische landesforsten': 'forstwirt', 'landesforsten': 'forstwirt', 'förster': 'forstwirt',
      'einbürgerung': 'einbürgerungstest', 'einbuergerungstest': 'einbürgerungstest', 'einbuergerungstedt': 'einbürgerungstest', 'einbuergerungstedt-vorbereitung': 'einbürgerungstest',
      'bkk': 'sozialversicherungsfachangestellter', 'dak': 'sozialversicherungsfachangestellter', 'tk': 'sozialversicherungsfachangestellter',
      'krankenkasse': 'sozialversicherungsfachangestellter', 'techniker krankenkasse': 'sozialversicherungsfachangestellter',
      'polizei bw': 'polizei baden-württemberg', 'polizei bawü': 'polizei baden-württemberg', 'polizei bawue': 'polizei baden-württemberg', 'polizei by': 'polizei bayern', 'polizei nds': 'polizei niedersachsen', 'polizei rlp': 'polizei rheinland-pfalz', 'polizei sh': 'polizei schleswig-holstein', 'polizei mv': 'polizei mecklenburg-vorpommern', 'polizei bb': 'polizei brandenburg', 'polizei lsa': 'polizei sachsen-anhalt', 'polizei hh': 'polizei hamburg', 'polizei hb': 'polizei bremen', 'polizei he': 'polizei hessen', 'polizei sn': 'polizei sachsen', 'polizei th': 'polizei thüringen', 'polizei sl': 'polizei saarland',
      'feuerwehr köln': 'feuerwehr nrw', 'feuerwehr koeln': 'feuerwehr nrw', 'feuerwehr dortmund': 'feuerwehr nrw', 'feuerwehr essen': 'feuerwehr nrw', 'feuerwehr duisburg': 'feuerwehr nrw', 'feuerwehr wuppertal': 'feuerwehr nrw', 'feuerwehr bielefeld': 'feuerwehr nrw', 'feuerwehr bonn': 'feuerwehr nrw', 'feuerwehr münster': 'feuerwehr nrw', 'feuerwehr muenster': 'feuerwehr nrw', 'feuerwehr gelsenkirchen': 'feuerwehr nrw', 'feuerwehr mönchengladbach': 'feuerwehr nrw', 'feuerwehr krefeld': 'feuerwehr nrw', 'feuerwehr hamm': 'feuerwehr nrw', 'feuerwehr oberhausen': 'feuerwehr nrw', 'feuerwehr hagen': 'feuerwehr nrw', 'feuerwehr leverkusen': 'feuerwehr nrw', 'feuerwehr solingen': 'feuerwehr nrw', 'feuerwehr neuss': 'feuerwehr nrw', 'feuerwehr paderborn': 'feuerwehr nrw', 'feuerwehr recklinghausen': 'feuerwehr nrw', 'feuerwehr siegen': 'feuerwehr nrw', 'feuerwehr gütersloh': 'feuerwehr nrw', 'feuerwehr herne': 'feuerwehr nrw', 'feuerwehr moers': 'feuerwehr nrw', 'feuerwehr wesel': 'feuerwehr nrw',
      'polizei köln': 'polizei nrw', 'polizei koeln': 'polizei nrw', 'polizei dortmund': 'polizei nrw', 'polizei essen': 'polizei nrw', 'polizei duisburg': 'polizei nrw', 'polizei wuppertal': 'polizei nrw', 'polizei bielefeld': 'polizei nrw', 'polizei bonn': 'polizei nrw', 'polizei münster': 'polizei nrw', 'polizei muenster': 'polizei nrw', 'polizei gelsenkirchen': 'polizei nrw', 'polizei mönchengladbach': 'polizei nrw', 'polizei krefeld': 'polizei nrw', 'polizei hamm': 'polizei nrw', 'polizei oberhausen': 'polizei nrw', 'polizei hagen': 'polizei nrw', 'polizei leverkusen': 'polizei nrw', 'polizei solingen': 'polizei nrw', 'polizei neuss': 'polizei nrw', 'polizei paderborn': 'polizei nrw', 'polizei recklinghausen': 'polizei nrw', 'polizei siegen': 'polizei nrw', 'polizei gütersloh': 'polizei nrw', 'polizei herne': 'polizei nrw', 'polizei moers': 'polizei nrw', 'polizei wesel': 'polizei nrw' };
    function kuerzel(q) {
      var k = String(q || '').trim().toLowerCase().replace(/\s+/g, ' ');
      return Object.prototype.hasOwnProperty.call(KUERZEL, k) ? KUERZEL[k] : q;
    }
    /* Volle Suchseite (Enter im Kopf oder im Suchfeld auf /search) bekommt dieselbe Abbildung wie das Dropdown */
    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (!f || f.tagName !== 'FORM' || (f.getAttribute('action') || '').split('?')[0] !== suchUrl) { return; }
      var feld = f.querySelector('input[name="q"]');
      if (feld && feld.value) { feld.value = kuerzel(feld.value); }
    }, true);
    function hole(q) {
      if (cache[q]) { return Promise.resolve(cache[q]); }
      if (laufend) { laufend.abort(); }
      laufend = typeof AbortController === 'function' ? new AbortController() : null;
      var url = new URL(vorschlagUrl, window.location.origin);
      url.searchParams.set('q', kuerzel(q));
      url.searchParams.set('section_id', 'th-v2-predictive-search');
      url.searchParams.set('resources[type]', 'product,collection,article');
      url.searchParams.set('resources[limit]', '10');   /* Tom 16.10.2026: mehr holen, Ranking in th-v2-predictive-search */
      url.searchParams.set('resources[limit_scope]', 'each');
      return window.fetch(url.toString(), { signal: laufend ? laufend.signal : undefined, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
        .then(function (html) {
          var doc = new window.DOMParser().parseFromString(html, 'text/html');
          var erg = doc.querySelector('[data-th-v2-suche-ergebnis]');
          var daten = { anzahl: erg ? (parseInt(erg.getAttribute('data-anzahl'), 10) || 0) : 0, html: erg ? erg.innerHTML : '' };
          cache[q] = daten;
          return daten;
        });
    }
    function rendere(q) {
      hole(q).then(function (d) {
        if (q !== letzte || overlay.hidden) { return; }
        if (!d.anzahl) { if (liste) { liste.innerHTML = ''; } zustand('null'); melde('Keine Treffer für ' + q); return; }
        if (liste) { liste.innerHTML = d.html; }
        zustand('treffer');
        melde(d.anzahl + ' Treffer für ' + q);
      }).catch(function (e) {
        if ((e && e.name === 'AbortError') || q !== letzte) { return; }
        zustand('leer');
        melde('Vorschläge sind gerade nicht verfügbar. Mit Enter startest du die Suche.');
      });
    }
    function verarbeite(wert) {
      window.clearTimeout(timer);
      var q = wert.trim();
      inputs.forEach(function (i) { if (i !== aktivInput) { i.value = wert; } });
      qsa('[data-th-search-clear]', wrap).forEach(function (c) { c.hidden = !wert; });
      letzte = q;
      if (q.length < 2) { if (laufend) { laufend.abort(); } zustand('leer'); melde(''); return; }   /* kein veralteter Status (3b-2) */
      if (cache[q]) { rendere(q); return; }
      zustand('laden');
      timer = window.setTimeout(function () { rendere(q); }, 220);
    }

    function oeffne(input, neuerModus) {
      aktivInput = input;
      if (!overlay.hidden && modus === neuerModus) { return; }
      modus = neuerModus;
      overlay.hidden = false;
      overlay.classList.add('is-open');
      if (modus === 'overlay') {
        /* mobiles Vollbild = modaler Dialog (WCAG 4.1.2); das Desktop-Dropdown bleibt Listbox ohne Dialogrolle */
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', 'Suche');
        sperreScroll(true);
        inertAb = hintergrundInert(overlay);
        falle = fokusfalle(overlay, qs('[data-th-search-input]', overlay) || input);
        oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      } else {
        overlay.removeAttribute('role');
        overlay.removeAttribute('aria-modal');
        overlay.removeAttribute('aria-label');
      }
      escAb = onEsc(function () { schliesse(true); });
      verarbeite(input.value);
    }
    function schliesse(fokus) {
      if (overlay.hidden) { return; }
      window.clearTimeout(timer);
      if (laufend) { laufend.abort(); }
      melde('');                                        /* 3b-4: kein Status ohne sichtbare Liste */
      markiere(-1);
      overlay.hidden = true;
      overlay.classList.remove('is-open');
      comboAbgleichen();
      inputs.forEach(function (i) { i.setAttribute('aria-expanded', 'false'); i.removeAttribute('aria-activedescendant'); });
      if (escAb) { escAb(); escAb = null; }
      if (modus === 'overlay') {
        sperreScroll(false);
        if (inertAb) { inertAb(); inertAb = null; }
        overlay.removeAttribute('role');
        overlay.removeAttribute('aria-modal');
        overlay.removeAttribute('aria-label');
        oeffner.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
      if (falle) { falle.loesen(oeffner[0]); falle = null; }
      else if (fokus && aktivInput) {
        fokusRuhe = true;                               /* Fokus zurück ins Feld, ohne das Dropdown erneut zu öffnen */
        aktivInput.focus();
        window.setTimeout(function () { fokusRuhe = false; }, 0);
      }
      modus = null;
    }

    inputs.forEach(function (input) {
      var imOverlay = overlay.contains(input);
      /* Combobox-Muster (WCAG 2.4.3): öffnet bei Eingabe, Pfeil ↓ oder Klick ins Feld – nicht beim Tab-Fokus */
      input.addEventListener('focus', function () { if (!fokusRuhe) { aktivInput = input; } });
      input.addEventListener('pointerdown', function () { if (!imOverlay && overlay.hidden && desktop.matches && !hdr.classList.contains('is-eng')) { oeffne(input, 'dropdown'); } });
      /* nur Nutzereingaben öffnen (Chrome leert type=search beim zweiten Esc mit input-Ereignis ohne inputType, 3b-3) */
      input.addEventListener('input', function (ev) {
        aktivInput = input;
        if (overlay.hidden && !imOverlay && ev.inputType) { oeffne(input, 'dropdown'); return; }
        verarbeite(input.value);
      });
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowDown' && overlay.hidden && !imOverlay) { ev.preventDefault(); oeffne(input, 'dropdown'); return; }
        var opts = optionen();
        if (ev.key === 'ArrowDown' && opts.length) { ev.preventDefault(); markiere((aktivIx + 1) % opts.length); }
        else if (ev.key === 'ArrowUp' && opts.length) { ev.preventDefault(); markiere(aktivIx <= 0 ? opts.length - 1 : aktivIx - 1); }
        else if (ev.key === 'Enter' && aktivIx > -1 && opts[aktivIx]) {
          ev.preventDefault();
          var a = opts[aktivIx].matches('a') ? opts[aktivIx] : qs('a', opts[aktivIx]);
          if (a) { window.location.href = a.href; }
        }
      });
    });
    qsa('[data-th-search-clear]', wrap).forEach(function (c) {
      c.addEventListener('click', function () {
        inputs.forEach(function (i) { i.value = ''; });
        verarbeite('');
        (aktivInput || inputs[0]).focus();
      });
    });
    oeffner.forEach(function (btn) {
      if (!einmal(btn)) { return; }
      btn.addEventListener('click', function () {
        var innen = qs('[data-th-search-input]', overlay) || inputs[0];
        oeffne(innen, 'overlay');
      });
    });
    qsa('[data-th-search-close]', overlay).forEach(function (btn) {
      btn.addEventListener('click', function () { schliesse(false); });
    });
    /* Maus auf einer Option markiert sie (Tastatur und Zeiger bleiben synchron) */
    overlay.addEventListener('mouseover', function (ev) {
      var o = ev.target.closest('[role="option"]');
      if (o) { markiere(optionen().indexOf(o)); }
    });
    document.addEventListener('pointerdown', function (ev) {
      if (!overlay.hidden && modus === 'dropdown' && !wrap.contains(ev.target)) { schliesse(false); }
    });
    wrap.addEventListener('focusout', function (ev) {
      var ziel = ev.relatedTarget;
      if (!overlay.hidden && modus === 'dropdown' && ziel && !wrap.contains(ziel)) { schliesse(false); }
    });
    beiWechsel(desktop, function () { schliesse(false); });
    hdr.__thV2SucheZu = function () { schliesse(false); };
    zustand('leer');
  }

  /* ======================================================================
     5. Warenkorb: Philipps Drawer öffnen, Zähler aktualisieren
     ====================================================================== */
  function drawerElement() { return document.querySelector('cart-drawer-component'); }

  function initWarenkorb(hdr) {
    qsa('[data-th-v2-cart-open]', hdr).forEach(function (btn) {
      if (!einmal(btn)) { return; }
      if (drawerElement()) {
        btn.setAttribute('role', 'button');
        btn.setAttribute('aria-haspopup', 'dialog');
      }
      /* Ziel der Fly-to-cart-Animation: product-form.js und sticky-add-to-cart.js suchen per querySelector die erste
         .header-actions__cart-icon. Der v2-Header steht vor dem (ausgeblendeten) Horizon-Symbol im Drawer-Träger. */
      var ziel = qs('[data-th-v2-cart-ziel]', btn);
      if (ziel) { ziel.classList.add('header-actions__cart-icon'); }
      btn.addEventListener('click', function (ev) {
        var drawer = drawerElement();
        if (!drawer || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || (ev.button && ev.button > 0)) { return; }
        ev.preventDefault();
        if (hdr.__thV2MegaZu) { hdr.__thV2MegaZu(false); }
        var los = function () {
          var d = drawerElement();
          if (d && typeof d.open === 'function') { d.returnFocusTo = btn; d.open(); }
          else { window.location.href = btn.getAttribute('href'); }
        };
        if (window.customElements && window.customElements.get('cart-drawer-component')) { los(); }
        else if (window.customElements) { window.customElements.whenDefined('cart-drawer-component').then(los); }
        else { window.location.href = btn.getAttribute('href'); }
      });
      btn.addEventListener('keydown', function (ev) {
        if ((ev.key === ' ' || ev.key === 'Spacebar') && btn.getAttribute('role') === 'button') { ev.preventDefault(); btn.click(); }
      });
    });
  }

  function setzeZaehler(n) {
    qsa('[data-th-v2-cart-open]').forEach(function (btn) {
      var z = qs('[data-th-cart-count]', btn);
      if (z) { z.textContent = String(n); z.hidden = !(n > 0); }
      btn.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel');
    });
  }
  var zaehlerTimer = null;
  function holeZaehler() {
    window.clearTimeout(zaehlerTimer);
    zaehlerTimer = window.setTimeout(function () {
      var hdr = qs('[data-th-v2-hdr]');
      if (!hdr) { return; }
      var basis = (hdr.getAttribute('data-cart-url') || '/cart').replace(/\/$/, '');
      window.fetch(basis + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.item_count === 'number') { setzeZaehler(c.item_count); } })
        .catch(function () { /* Zähler bleibt, nächstes cart:update versucht es erneut */ });
    }, 120);
  }
  /* cart:update = ThemeEvents.cartUpdate (Horizon, th-v2.js, Drawer). resource.item_count ist nur bei /cart/change gesetzt;
     sonst (z. B. /cart/add, Quelle product-form-component = Zuwachs statt Summe) wird /cart.js gelesen. */
  document.addEventListener('cart:update', function (ev) {
    var d = (ev && ev.detail) || {};
    if (d.resource && typeof d.resource.item_count === 'number') { setzeZaehler(d.resource.item_count); return; }
    holeZaehler();
  });
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { holeZaehler(); } });

  /* ======================================================================
     6. Ankündigungsleiste
     ====================================================================== */
  function praeferenzenErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed());
    } catch (e) { return false; }
  }
  function initAnkuendigung(root) {
    qsa('[data-th-v2-announcement]', root).forEach(function (leiste) {
      if (!einmal(leiste)) { return; }
      var schluessel = 'th-v2-ankuendigung-zu:' + leiste.getAttribute('data-th-v2-announcement');
      var lese = function () { try { return window.sessionStorage.getItem(schluessel) === '1'; } catch (e) { return false; } };
      var schreibe = function (an) {
        try { if (an) { window.sessionStorage.setItem(schluessel, '1'); } else { window.sessionStorage.removeItem(schluessel); } } catch (e) { /* Privatmodus */ }
      };
      if (praeferenzenErlaubt() && lese()) { leiste.hidden = true; return; }
      document.addEventListener('visitorConsentCollected', function () {
        if (!praeferenzenErlaubt()) { schreibe(false); return; }
        if (leiste.hidden) { schreibe(true); }
      });
      var zu = qs('[data-th-v2-announcement-close]', leiste);
      if (!zu) { return; }
      zu.addEventListener('click', function () {
        var hatteFokus = leiste.contains(document.activeElement);
        leiste.hidden = true;
        if (praeferenzenErlaubt()) { schreibe(true); }
        /* WCAG 2.4.3: nächstes sinnvolles Ziel ist der Logo-Link im Header, sonst der Inhalt */
        if (hatteFokus) {
          var ziel = qs('[data-th-v2-hdr] .th-nav__home') || qs('#MainContent');
          if (ziel) { if (ziel.id === 'MainContent' && !ziel.hasAttribute('tabindex')) { ziel.setAttribute('tabindex', '-1'); } ziel.focus(); }
        }
      });
    });
  }

  /* ======================================================================
     7. Steuerhinweis-Absicherung (Toms Entscheid 15.10.2026)
     Befreite Positionen tragen die sichtbare Line-Item-Property „Hinweis“ (Warenkorb, Checkout, Bestellung, Mail,
     Rechnung). v2-Formulare setzen sie selbst (Snippet th-v2-steuer-hinweis, gleicher Wortlaut); hier werden Wege
     ohne das Feld nachgezogen. Maßstab ist das Varianten-Flag taxable (Sync aus WooCommerce).
     ====================================================================== */
  var HINWEIS_KEY = 'Hinweis';
  var HINWEIS = 'Dieses Produkt ist gem. § 4 Nr. 21 UStG von der Umsatzsteuer befreit.';
  var STEUER_QUELLE = 'th-v2-steuerhinweis';
  var steuerLaeuft = null;
  var steuerNochmal = false;
  var steuerTimer = null;
  function cartBasis() {
    var hdr = qs('[data-th-v2-hdr]');
    return ((hdr && hdr.getAttribute('data-cart-url')) || '/cart').replace(/\/$/, '');
  }
  function steuerSoll(it) {
    var p = it.properties || {};
    var hat = !!p[HINWEIS_KEY];
    if (it.taxable === false && !hat) {
      var neu = {};
      Object.keys(p).forEach(function (k) { neu[k] = p[k]; });
      neu[HINWEIS_KEY] = HINWEIS;
      return neu;
    }
    if (it.taxable === true && hat && String(p[HINWEIS_KEY]).indexOf('4 Nr. 21 UStG') !== -1) {
      var ohne = {};
      Object.keys(p).forEach(function (k) { if (k !== HINWEIS_KEY) { ohne[k] = p[k]; } });
      return ohne;
    }
    return null;
  }
  function steuerSektionen() {
    var ids = [];
    qsa('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) { ids.push(id); }
    });
    return ids;
  }
  function steuerPruefen() {
    if (!window.fetch) { return null; }
    if (steuerLaeuft) { steuerNochmal = true; return steuerLaeuft; }
    var basis = cartBasis();
    var geaendert = null;
    var json = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    steuerLaeuft = window.fetch(basis + '.js', json)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) { return null; }
        var auftraege = [];
        cart.items.forEach(function (it) {
          var props = steuerSoll(it);
          if (!props) { return; }
          if (Object.keys(props).length) {
            auftraege.push([{ pfad: '/change.js', body: { id: it.key, quantity: it.quantity, properties: props } }]);
          } else {
            /* /cart/change.js ignoriert leere properties: Position ohne Properties neu anlegen */
            auftraege.push([{ pfad: '/change.js', body: { id: it.key, quantity: 0 } }, { pfad: '/add.js', body: { items: [{ id: it.variant_id, quantity: it.quantity }] } }]);
          }
        });
        if (!auftraege.length) { return null; }
        var ids = steuerSektionen();
        var schritte = [].concat.apply([], auftraege);
        var senden = function (schritt) {
          return window.fetch(basis + schritt.pfad, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(schritt.body)
          }).then(function (r) { return r.ok ? r.json() : null; });
        };
        /* Nacheinander: der Schlüssel einer Position ändert sich nur für die geänderte Zeile. Zum Schluss ein
           /cart/update.js ohne Änderung, das den ganzen Warenkorb samt Section-HTML für den Drawer liefert. */
        return schritte.reduce(function (kette, schritt) {
          return kette.then(function () { return senden(schritt); });
        }, Promise.resolve()).then(function () {
          var abschluss = { updates: {} };
          if (ids.length) { abschluss.sections = ids.join(','); abschluss.sections_url = window.location.pathname; }
          return senden({ pfad: '/update.js', body: abschluss });
        }).then(function (d) { if (d && d.items) { geaendert = d; } });
      })
      .then(function () {
        var hdr = qs('[data-th-v2-hdr]');
        if (hdr) { hdr.removeAttribute('data-th-v2-steuer-offen'); }
        if (!geaendert) { return; }
        /* Warenkorbseite v2 hält Zeilenschlüssel im Markup: einmal neu laden; sonst Drawer per cart:update morphen */
        if (qs('[data-th-v2-warenkorb]')) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: geaendert, sourceId: STEUER_QUELLE, data: { source: STEUER_QUELLE, itemCount: geaendert.item_count, sections: geaendert.sections } }
        }));
      })
      .catch(function () { /* nächstes cart:update versucht es erneut */ })
      .then(function () {
        steuerLaeuft = null;
        if (steuerNochmal) { steuerNochmal = false; planeSteuer(); }
      });
    return steuerLaeuft;
  }
  function planeSteuer() {
    window.clearTimeout(steuerTimer);
    steuerTimer = window.setTimeout(function () { steuerTimer = null; steuerPruefen(); }, 250);
  }
  document.addEventListener('cart:update', function (ev) {
    var d = (ev && ev.detail) || {};
    if (d.sourceId === STEUER_QUELLE || (d.data && d.data.source === STEUER_QUELLE)) { return; }
    planeSteuer();
  });
  /* Kasse erst nach laufender Korrektur: Klick auf einen Checkout-Knopf wartet kurz und wird dann wiederholt */
  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('button[name="checkout"], a[href*="/checkout"], [data-th-v2-kasse-knopf]') : null;
    if (!el || el.__thV2SteuerWeiter) { return; }
    var offen = !!qs('[data-th-v2-hdr][data-th-v2-steuer-offen]');
    if (!steuerLaeuft && !steuerTimer && !offen) { return; }
    ev.preventDefault();
    ev.stopImmediatePropagation();
    window.clearTimeout(steuerTimer);
    steuerTimer = null;
    var weiter = function () { el.__thV2SteuerWeiter = true; el.click(); window.setTimeout(function () { el.__thV2SteuerWeiter = false; }, 0); };
    (steuerLaeuft || steuerPruefen() || Promise.resolve()).then(weiter, weiter);
  }, true);
  function initSteuer() {
    if (qs('[data-th-v2-hdr][data-th-v2-steuer-offen]')) { steuerPruefen(); }
  }

  /* ---------- Start ---------- */
  function init(root) {
    var r = root || document;
    var hdrs = qsa('[data-th-v2-hdr]', r);
    if (r.matches && r.matches('[data-th-v2-hdr]')) { hdrs.push(r); }
    hdrs.forEach(initHeader);
    initAnkuendigung(r);
    if (r === document) { initSteuer(); }
  }
  window.thV2Header = { init: init, setzeZaehler: setzeZaehler };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
